<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='“VR云游中国 有声旅游护照”线上旅游活动'">
    <img class="img-deng1" src="../../assets/zhongqiu/deng1.png" alt="">
    <img class="img-deng2" src="../../assets/zhongqiu/deng2.png" alt="">
    <img class="img-deng3" src="../../assets/zhongqiu/deng3.png" alt="">
    <img class="img-deng4" src="../../assets/zhongqiu/deng1.png" alt="">
    <img class="img-logo" src="../../assets/zhongqiu/logo.png" alt="">
    <img class="img-txt" src="../../assets/zhongqiu/txt.png" alt="">
    <img class="img-main" src="../../assets/zhongqiu/main.png" alt="">


    <div class="cont border-box">
      <div class="cont-tit"><span><font>领用规则</font></span></div>
      <div class="cont-txt">
        <!--1.参与资格：仅限成都地区用户参与，每个微信号限领1次；<br>-->
        <!--2.领取方式：扫码关注“ 金牌解说公众号 ”，点击链接即可领取，在金牌解说首页，右下方“我的”查看到账情况；<br>-->
        <!--3.领取时间：9月10日至12日（中秋节3天）；<br>-->
        <!--4.领取成功：自动解锁“ VR云游中国 · 有声电子旅游护照 ”免费畅听30天；<br>-->
        <!--5.使用时间：自领取后30天内有效，逾期作废； <br>-->
        <!--6.温馨提示：如遇问题可在“ 金牌解说公众号 ”联系客服处理。-->
        1、参与资格：仅限成都地区用户参与，每个微信号限领1次；<br>
        2、领取时间：从现在起--9月12日23点59分59秒。<br>
        3、使用时间：畅听畅看权限，自领取日起30日内有效。<br>
        <p v-if="tel">4、客服电话：<a :href="'tel:'+tel[0]">{{tel[0]}}</a>  /  <a :href="'tel:'+tel[1]">{{tel[1]}}</a>  <br></p>

      </div>
    </div>

    <div class="btn-box border-box">
      <div class="btn" :class="(isCD&&isZQ && !isLQ)?'':'dis'" @click="getReceiveFun">{{isLQ?'您已领取':'立即领取'}}</div>
      <div class="btn-tip" v-if="isOver===1">活动已结束</div>
      <div class="btn-tip" v-else-if="isOver!==''">距活动结束还剩 {{isOver}}</div>
    </div>

  </div>


</template>
<script>
  import {isReceive,getReceive} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo,} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        cityName: '',
        userInfo: {}, //用户信息
        userInfo1: {}, //用户信息
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: "1", city: "全部", address: "" },

        isLQ: false, //是否已经领取  0 未领取  1已领取
        isCD: true, //判断是否在成都
        isZQ: true, //判断是中秋节三天：2022-9-10，2022-9-11，2022-9-12
        days:['2022-9-10','2022-9-11','2022-9-12','2022-9-9'],
        isOver: '', //倒计时

        tel: '',
      }
    },
    computed: {},

    created(){
      let self = this;
      this.userInfo = getStore("userInfo");
      this.userInfo1 = getStore("userInfo1",1);


      var date = new Date()
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var today = y+'-'+m+'-'+d;

      this.isZQ = (this.days.indexOf(today)>-1?true:false);

      this.countTime('2022-09-12 23:59:59');

      getCityInfo(function (res) {
        self.latlng = res;
        self.cityInfo = getStore("cityInfo");
        if(self.cityInfo && self.cityInfo.citycode=='510100'){
          self.isCD = true;
        }else {
          self.isCD = false;
        }

        self.isReceiveFun();
      });



    },
    methods: {

      //判断用户是否已经激活过
      async isReceiveFun(){
        let res = await isReceive({
          openid: this.userInfo.openid,
        });
        if (res.errcode === "00000"){
          if(res.data && res.data.type==1){
            this.isLQ = true;

            var self = this;
            this.$alert({
              title: '提示',
              content: '您已领取该有声电子旅游护照',
              btnText: '去听解说'
            }).then(function(res){
              if(res == 'ok') {
                self.$router.replace({
                  path: `/?siteid=&sregion=&appKey=`
                });
              }
            }).catch(function(res){
              if(res == 'ok') {
                self.$router.replace({
                  path: `/?siteid=&sregion=&appKey=`
                });
              }
            });
          }else{
            this.isLQ = false
          }
          if(res.data.list){
            this.tel = res.data.list;
          }

        }

        function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
        }

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          onBridgeReady();
        }

//        let title = '“VR云游中国 有声旅游护照”线上旅游活动';
//        let desc = 'VR看、听讲解全国700家文博景区！5000位金牌讲解员带您游！中秋节免费领30天畅听会员';
//        let link = '/zhongqiu?siteid=&sregion=&appKey=';
//        wxShareme(title,desc,'',link);
      },

      //立即激活
      async getReceiveFun(){

        if(!this.latlng.lat || !this.latlng.lng || !this.isCD){
          this.$toast('您定位不在成都所属区域');
          return
        }
        if(!this.isZQ){
          this.$toast('当前不在活动领取时间');
          return
        }

        if(this.isLQ){
          this.$toast('您已领取该活动');
          return
        }

        var self = this;
        let res = await getReceive({
          openid: this.userInfo.openid,
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          code: this.cityInfo.citycode || ''
        });
        if (res.errcode == '00000') {
          this.$alert({
            title: '提示',
            content: '激活成功',
            btnText: '去听解说'
          }).then(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?siteid=&sregion=&appKey=`
              });
            }
          }).catch(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?siteid=&sregion=&appKey=`
              });
            }
          });
        }else {
          this.$alert({
            title: '提示',
            content: res.message,
          });
        }
      },

      //倒计时
      countTime: function(etime) {
        var self = this;

        //获取当前时间
        var date = new Date();
        var ntime = date.getTime();

        var str = etime;
        if (etime) {
          if (typeof etime === 'string') {
            str = new Date(etime.replace(/-/g, "/"));
          } else if (typeof etime === 'number') {
            str = new Date(etime);
          }
        }
        etime = (new Date(str)).getTime();
        //时间差
        var leftTime = etime-ntime;


        if(leftTime <= 0){  //时间已过
          self.isOver = 1;
        }else {
          //定义变量 d,h,m,s保存倒计时的时间
          var d,h,m,s;
          if (leftTime>=0) {
            d = Math.floor(leftTime/1000/60/60/24);
            h = Math.floor(leftTime/1000/60/60%24);
            m = Math.floor(leftTime/1000/60%60);
            s = Math.floor(leftTime/1000%60);
            h = h>9?h:'0'+h;
            m = m>9?m:'0'+m;
            s = s>9?s:'0'+s;
          }

          var txt = '';
          if(d>0){
            txt = d + '天 ' +h+':'+m+':'+s
          }else {
            txt = h+':'+m+':'+s
          }
          self.isOver = txt;

          //递归每秒调用countTime方法，显示动态时间效果
          setTimeout(function(){
            self.countTime(etime)
          },1000);
        }
      },


  },

  }

</script>

<style scoped>
  @import "../../style/view.css";

  .page{position: relative; width: 100%; padding:0;height: 250vw;background: #502583 url(../../assets/zhongqiu/bg.png) no-repeat;background-size: 100% 100%;background-attachment: fixed;overflow-x: hidden;}
  .img-deng1{position: absolute;top:75vw;left: -42vw;width: 51vw;height:auto;z-index: 1;pointer-events: none;}
  .img-deng2{position: absolute;top:6vw;left: -4vw;width: 58vw;height:auto;z-index: 1;pointer-events: none;}
  .img-deng3{position: absolute;top:0;right: 0;width: 25.3vw;height:auto;z-index: 1;pointer-events: none;}
  .img-deng4{position: absolute;top:28.3vw;right: -41vw;width: 51vw;height:auto;z-index: 1;pointer-events: none;}
  .img-logo{position: absolute;top:5.2vw;left: 5.2vw;width: 65.5vw;height:auto;z-index: 1;pointer-events: none;}
  .img-txt{position: absolute;top:28.3vw;left: 5.75vw;width: 88.5vw;height:auto;z-index: 1;pointer-events: none;}
  .img-main{position: absolute;top:84.4vw;left: 0;width: 100vw;height:auto;z-index: 2;pointer-events: none;}

  .cont{position: absolute;top:145vw;left: 0;bottom:0;width: 100vw;z-index: 1;padding: 2rem .3rem 1.2rem;border-radius: .24rem .24rem 0 0;background: #fff;}
  /*标题样式*/
  .cont-tit{position:relative;font: bold .32rem/.54rem "Microsoft YaHei";color: #333;}
  .cont-tit span{position:relative;}
  .cont-tit span:after{content: '';position: absolute;left: 0;right:0;bottom:.08rem;height: .08rem;background: #ffc200;}
  .cont-tit span font{position: relative;z-index: 1;}
  .cont-txt{ margin-top: .24rem; font: .26rem/.54rem "Microsoft YaHei";color: #555;}
  .cont-txt a{ color: #222;font-weight: bold;}

  .btn-box{position: fixed;left: 0;right: 0;bottom:0;z-index: 3; padding: .13rem .55rem .35rem; background: #f5f5f5;border-top:1px solid #e3e3e3;}
  .btn-box .btn{ display: block;width: 100%; height: .96rem;line-height: .96rem; font: bold .4rem/.96rem "Microsoft YaHei";color: #000; text-align: center; letter-spacing: .05rem; background: #f5bd1e;border-radius: .96rem;}
  .btn-box .btn.dis{  background: #ccc;color: #666;}
  .btn-box .btn-tip{position: absolute; left: 16%; top:-.66rem;right:16%;width: 68%;height:.66rem;border-radius: .3rem .3rem 0 0;font-size: .32rem;line-height: .66rem;color: #fff;background: #fb4a21;text-align: center;}


</style>




// WEBPACK FOOTER //
// src/page/h5/zhongqiu.vue